/* src/app/shared-module/components/error/error.component.scss */
/*# sourceMappingURL=error.component.css.map */
